module.exports = __webpack_public_path__ + "static/hero-img@3x-209d56ea7cb2cb0c1296877b6551a4cb.png";